// "just now" / "4 min ago" / "3 hrs ago" / "3 days ago" / null (no timestamp). Past-or-now
// only: a positive diff can only mean clock skew, so it clamps to "just now" instead of
// going negative. Pure (no DOM, no api.js) so node:test can import it without stubs —
// shared by the server-agent wizard (lib/server-agent-command.js) and the dashboard's
// project-banner "last activity" caption (pages/dashboard.js, TPT400).
export function relativeTime(iso, now = Date.now()) {
  if (!iso) return null;
  const diffMs = now - new Date(iso).getTime();
  if (!Number.isFinite(diffMs) || diffMs < 0) return 'just now';
  const min = Math.floor(diffMs / 60000);
  if (min < 1) return 'just now';
  if (min < 60) return `${min} min ago`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr} hr${hr === 1 ? '' : 's'} ago`;
  const day = Math.floor(hr / 24);
  return `${day} day${day === 1 ? '' : 's'} ago`;
}
